import { GrupoDadosExportar } from './grupo-dados-exportar';

export class DadosExportar {
	dados: GrupoDadosExportar[] = [];
}